import { render } from "./LicenseOldMain.vue?vue&type=template&id=4cbf32a8"
import script from "./LicenseOldMain.vue?vue&type=script&lang=js"
export * from "./LicenseOldMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__